"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onCanPlay;
function onCanPlay(event) {
  if (this.logger.times.LoadTimeVideo > 0) {
    this.logger.times.LoadTimeVideo = performance.now() - this.logger.times.LoadTimeVideo;
    this.logger.logTime('LoadTime-Video', this.logger.times.LoadTimeVideo);
    if (this.logger.times.LoadTimeInit > 0) {
      var loadTime = this.logger.times.LoadTimeInit + this.logger.times.LoadTimeVideo;
      this.logger.logTime('LoadTime', loadTime);
      this.logger.times.LoadTimeInit = 0;
    }
    this.logger.times.LoadTimeVideo = 0;
    this.logger.times.BufferTime = 0;
  }
  this._transitionToNextClip = false;
  this.emit('canplay', event);
}